import React from 'react';

import { useData } from '@shared/api/hooks/useData';
import { ParkingStickersDataTable } from '@shared/parking-requests/components/ParkingStickersDataTable/ParkingStickersDataTable';
import { getRegistrationParkingStickers } from '@shared/parking-stickers/endpoints/getRegistrationParkingStickers';
import { Portlet } from '@shared/ui/components/Portlet';

type ParkingRequestParkingSticker = App.Domain.Parking.Data.ParkingRequestParkingStickerData;

export function ListRegistrationParkingStickers({ match }: { match: any }) {
  const registrationId = match.params.id;

  const parkingStickers = useData<ParkingRequestParkingSticker>({
    key: 'registration-parking-stickers',
    get: (query) => getRegistrationParkingStickers(registrationId, query),
    defaults: {
      sort: '-created_at',
      include: [
        'parkingRequest.crewMember.user',
        'parkingRequest.crewMember.registration.company',
        'parkingRequest.parking',
        'parkingSticker',
        'claimedByCrewMember.user',
        'handledByUser',
      ],
    },
  });

  return (
    <Portlet title="Parking Stickers">
      <ParkingStickersDataTable parkingStickers={parkingStickers} registrationId={registrationId} />
    </Portlet>
  );
}
